import { useMemo, useState } from "react"

import { App } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import ExportDataModal from "../../../../Components/ExportDataModal/ExportDataModal"
import { getExportPeriodLabel } from "../../../../Components/ExportDataModal/getExportPeriodLabel"
import { getCompareParams } from "../../../../Components/Filters/CompareSelect/presets"
import { getApiErrorMessage } from "../../../../Utils/thunkHelpers"
import { getDates } from "../../../../Utils/utils"
import * as services from "../../services"

const EXPORT_TABLES = [
  {
    key: "overview",
    label: "Dashboard Overview page",
    tooltip:
      "Summary of all overview data for the selected period. For more detail, export individual data tables",
    forbiddenFormatsWhenAlone: ["csv"]
  },
  { key: "by_source", label: "Alerts by Source" },
  { key: "by_descriptor", label: "Alerts by Descriptor" },
  { key: "by_country", label: "Alerts by Country" },
  { key: "by_bank", label: "Alerts by Bank" },
  { key: "by_outcome", label: "Alerts by Outcome" },
  { key: "by_card_type", label: "Alerts by Card Type" }
]

const EXPORT_FORMATS = [
  { value: "pdf", label: "PDF" },
  { value: "csv", label: "CSV" }
]

const ExportDashboardOverviewModal = ({
  open,
  onClose,
  filters,
  businessAccountId,
  isAdmin,
  testData,
  descriptors
}) => {
  const { t } = useTranslation()
  const { notification } = App.useApp()
  const lang = useSelector((state) => state?.auth?.userInfo?.language) || "en"
  const [exporting, setExporting] = useState(false)

  const periodLabel = useMemo(() => getExportPeriodLabel(filters, { lang, t }), [filters, lang, t])

  const handleExport = async ({ tables, format }) => {
    setExporting(true)
    try {
      const periodDates = getDates(filters?.period)
      const compareParams = getCompareParams(filters?.compare, periodDates)
      const descriptorList = descriptors && descriptors !== "all" ? [].concat(descriptors) : null

      const response = await services.getDashboardExport({
        tables,
        format,
        ...periodDates,
        ...compareParams,
        ...(isAdmin ? { business_account_id: businessAccountId } : {}),
        ...(testData !== undefined ? { test_data: testData } : {}),
        ...(tables.includes("by_descriptor") && descriptorList?.length
          ? { filters: { by_descriptor: { descriptor: descriptorList } } }
          : {})
      })

      if (!response.ok) {
        notification.error({ message: await getApiErrorMessage(response) })
        return
      }

      notification.success({ message: response.data?.message })
      onClose()
    } finally {
      setExporting(false)
    }
  }

  return (
    <ExportDataModal
      open={open}
      onClose={onClose}
      onExport={handleExport}
      exporting={exporting}
      periodLabel={periodLabel}
      tables={EXPORT_TABLES}
      formats={EXPORT_FORMATS}
    />
  )
}

export default ExportDashboardOverviewModal
